module.exports = __webpack_public_path__ + "static/media/classicos_feminino_acessorios.0f47537e.jpg";